import { render } from "./declined.vue?vue&type=template&id=15feed39&scoped=true"
import script from "./declined.vue?vue&type=script&lang=js"
export * from "./declined.vue?vue&type=script&lang=js"

import "./declined.vue?vue&type=style&index=0&id=15feed39&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15feed39"]])

export default __exports__